"use client";

import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Cart() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="599" id="cart-content" className="bg-background text-foreground py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <div ref={ref} className={`mb-12 md:mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex flex-col gap-4 max-w-3xl">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-primary">
              Your Catch
            </span>
            <h1 className="font-serif font-default text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-foreground">
              The Galley Bag
            </h1>
            <p className="text-sm md:text-base text-muted-foreground font-default max-w-md">
              Review your wild-caught selection from The Miss Yvonne before we prepare your delivery from shore to door.
            </p>
          </div>
          <div className="mt-10 h-px w-full bg-border" />
        </div>

        <div className={`transition-all duration-700 delay-100 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <WooCommerceCartBlock />
        </div>
      </div>
    </section>;
}